module.exports = __webpack_public_path__ + "img/openbadge-intro-4.dc5ab487.png";